import React from "react";
import DataTable from "../../../components/DataTable";
const dataJson = [
  {
    id: "4347348",
    sn: "01",
    date: "01/03/2022",
    remarks: "78",
    credit: "$4789",
    debit: "$45855",
    charge: "$4870",
    balance: "$89584",
  },
  {
    id: "dfsfs8f",
    sn: "02",
    date: "01/03/2022",
    remarks: "78",
    credit: "$4789",
    debit: "$45855",
    charge: "$4870",
    balance: "$89584",
  },
  {
    id: "fsf7s8f",
    sn: "03",
    date: "01/03/2022",
    remarks: "78",
    credit: "$4789",
    debit: "$45855",
    charge: "$4870",
    balance: "$89584",
  },
];

const ActivationTxnHistoryTable = () => {
  const columns = [
    { id: "sn", label: "S.N", minWidth: 20 },
    { id: "date", label: "Date", minWidth: 100 },
    {
      id: "remarks",
      label: "Remarks",
      minWidth: 80,
    },
    {
      id: "credit",
      label: "Credit",
      minWidth: 80,
    },
    {
      id: "debit",
      label: "Debit",
      minWidth: 80,
    },
    {
      id: "charge",
      label: "Charge",
      minWidth: 80,
    },
    {
      id: "balance",
      label: "Balance",
      minWidth: 80,
    },
  ];

  function createData(sn, date, remarks, credit, debit, charge, balance) {
    return { sn, date, remarks, credit, debit, charge, balance };
  }

  const rows = dataJson.map((d) =>
    createData(d.sn, d.date, d.remarks, d.credit, d.debit, d.charge, d.balance)
  );
  return (
    <DataTable
      columns={columns}
      rows={rows}
      perPageShow={6}
      tableHeight={440}
      className="common_table"
    />
  );
};

export default ActivationTxnHistoryTable;
